export default __webpack_public_path__ + "static/media/compliance-bwg.3770fbe3.png";